module.exports = __webpack_public_path__ + "static/campaign-highlights-3528e76f01d5fc539827bc6b08cbca74.jpg";